export default __webpack_public_path__ + "static/media/3.096953b3.jpg";